
import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { SessionContextProvider } from '@supabase/auth-helpers-react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { supabase } from '@/integrations/supabase/client'
import { Toaster } from '@/components/ui/toaster'
import { ThemeProvider } from '@/components/ui/theme-provider'
import App from './App.tsx'
import './index.css'

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Failed to find the root element')

const root = createRoot(rootElement)

// Create a new QueryClient instance
const queryClient = new QueryClient()

root.render(
  <React.StrictMode>
    <ThemeProvider defaultTheme="light" storageKey="grace-awakens-theme">
      <QueryClientProvider client={queryClient}>
        <SessionContextProvider supabaseClient={supabase}>
          <BrowserRouter>
            <App />
            <Toaster />
          </BrowserRouter>
        </SessionContextProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>
)
